<script setup lang="ts">
  import TheToast from './components/the-toast.vue'
  import { useInitApp } from './models/init'

  const { initApp } = useInitApp()
  initApp()
</script>

<template>
  <app-router-view />
  <the-toast />
</template>

<style lang="postcss" scoped>
</style>
